import React, { useState, useEffect } from "react"
import "../Forms/Form.css"
import "../../Components/Commons/Commons.css"
import { useQuill } from "react-quilljs"
import "quill/dist/quill.snow.css"
import { formatDate } from "../../Assets/Helpers/Common"
import { FORM } from "../../Constants/doctor"

function Forms() {
  const { quill, quillRef } = useQuill()
  const currentDate = new Date()
  const header = `
    <div>
      <br/>
      <br/>
       <h1 style="text-align:center; font-size:18px">
        <strong>${FORM.header}</strong>
      </h1>
      <h2 style="text-align:center; font-size:5px">
      ${FORM.header2}
    </h2>
    
      <br/>
      <br/>
      <p style="text-align:center; font-size:18px">
        <strong>[LETTER TITLE HERE]</strong>
      </p>
      <br/>
      <br/>
     <p style="text-align:right">${formatDate(currentDate)}</p>
     <br/>
     <br/>
     <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
       <p style="text-align:right; font-size:18px">
        <strong>${FORM.footer.doctor_name}</strong>
      </p>
      <p style="text-align:right;">
        ${FORM.footer.license}
      </p>
      <p style="text-align:right;">
        ${FORM.footer.ptr}
      </p>
      <p style="text-align:right;">
        ${FORM.footer.s2_license}
      </p>
    </div>
  `
  const [content, setContent] = useState(header)

  useEffect(() => {
    if (quill) {
      quill.clipboard.dangerouslyPasteHTML(content)
    }
  }, [quill])

  return (
    <div className="row mt-1 quill-cont form-letter mb-4">
      <div>
        <div
          id="letterhead_content"
          ref={quillRef}
          style={{ minHeight: "68vh" }}
        />
      </div>
    </div>
  )
}
export default Forms
